module.exports = __webpack_public_path__ + "static/media/BrownMagical.67e02b19.jpg";